import React, { useState } from "react";
import "Pages/JobsLibrary/SbJobsLibrary.scss";
import HeaderSection from "Components/HeaderSection/HeaderSection";
import RoleViewTable from "./RoleTable/RoleViewTable";
import { Button, Card } from "react-bootstrap";
import Permission from "Components/Permission";
import { SbTooltip } from "uiCore";

const TOOLTIP_ADD_ROLE = "Add a new role to your organisation's job catalog.";

const RoleEntitlements = () => {

  const [isRoleDrawerOpen, setIsRoleDrawerOpen] = useState(false);

  return (
    <>
      <div className="jobs-library-container shadow-sm">
        <HeaderSection
          title="Manage Roles"
          description="A descriptive body text comes here"
         >
          <div className="d-flex align-items-center">
            <Permission resource="role" actions={["create"]}>
              <Card.Text className="mb-0">
                <small className="text-body-tertiary jobs-description mb-0 me-3">
                  Create new role:
                </small>
              </Card.Text>
              <SbTooltip content={TOOLTIP_ADD_ROLE}>
                <Button
                  className="btn btn-primary btn-md me-2 create-button btn-large icon-wrapper"
                  onClick={() => setIsRoleDrawerOpen(true)}
                >
                  Create New Role
                </Button>
              </SbTooltip>
            </Permission>
          </div>
        </HeaderSection>
        <RoleViewTable
          isRoleDrawerOpen={isRoleDrawerOpen}
          setIsRoleDrawerOpen={setIsRoleDrawerOpen}
        />
      </div>
    </>
  );
};

export default RoleEntitlements;
